<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="700">
    <v-row>
      <v-col>
        <v-text-field
          :outlined="outlinedInputs"
          hide-details
          label="Reference"
          v-model="reference"
        />
      </v-col>
    </v-row>
    <v-row v-if="!hideDates">
      <v-col>
        <dates-range
          :outlined="outlinedInputs"
          :gt-date-from-string="validFrom"
          :gt-date-to-string="validTo"
          @onRangeSelected="onDatesChange"
        ></dates-range>
      </v-col>
    </v-row>
    <v-row v-if="!hideDates">
      <v-col>
        <v-select
          item-text="name"
          item-value="value"
          :outlined="outlinedInputs"
          label="Days of Week"
          :items="daysOfWeek"
          v-model="selectedDaysOfWeek"
          multiple
          chips
          deletable-chips
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Min Pax:"
          v-model="minPax"
          type="number"
          :outlined="outlinedInputs"
          min="1"
          @change="setAdjustments"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Max Pax"
          v-model="maxPax"
          type="number"
          :outlined="outlinedInputs"
          min="1"
          @change="setAdjustments"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Step"
          v-model="step"
          type="number"
          :outlined="outlinedInputs"
          min="1"
          @change="setAdjustments"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card outlined>
          <v-data-table
            :headers="visibleHeaders"
            :items="adjustments"
            :items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:item.foc1="{ item }">
              <v-text-field
                type="number"
                v-model.number="item.foc1"
                min="0"
                class="pt-1 ma-0 short-input"
              ></v-text-field>
            </template>
            <template v-slot:item.foc2="{ item }">
              <v-text-field
                type="number"
                v-model.number="item.foc2"
                min="0"
                class="pt-1 ma-0 short-input"
              ></v-text-field>
            </template>
            <template v-slot:item.foc3="{ item }">
              <v-text-field
                type="number"
                v-model.number="item.foc3"
                min="0"
                class="pt-1 ma-0 short-input"
              ></v-text-field>
            </template>
            <template v-slot:item.foc4="{ item }">
              <v-text-field
                type="number"
                v-model.number="item.foc4"
                min="0"
                class="pt-1 ma-0 short-input"
              ></v-text-field>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="debug">
      <code>{{ dates }}</code>
    </div>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onAdd">Add</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog.vue";
import DatesRange from "../../../shared/DatesRangePicker";
import TemplateDepartureDateSelect from "../TemplateDepartureDateSelect";
const moment = require("moment");
const randomize = require("randomatic");
export default {
  name: "add-increment-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    departures: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => null,
    },
    templateItems: {
      type: Array,
      default: () => [],
    },
    hideDates: {
      type: Boolean,
      default: () => false,
    },
    date: {
      type: String,
      default: () => null,
    },
  },

  components: { BasicDialog, TemplateDepartureDateSelect, DatesRange },

  data() {
    return {
      debug: false,
      validFrom: "",
      validTo: "",
      reference: "",
      daysOfWeek: [
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
        {
          name: "Sunday",
          value: "0",
        },
      ],
      selectedDaysOfWeek: [],

      minPax: this.value ? this.value.minPax : 2,
      maxPax: this.value ? this.value.maxPax : 10,
      step: this.value ? this.value.step : 2,
      adjustments: [],
      adjustmentsHeaders: [
        {
          text: "Pax From",
          value: "paxFrom",
          name: "paxFrom",
          occupancy: 0,
        },
        {
          text: "Pax To",
          value: "paxTo",
          name: "paxTo",
          occupancy: 0,
        },
        {
          text: "FOC Single",
          value: "foc1",
          name: "foc1",
          occupancy: 1,
        },
        {
          text: "FOC Double",
          value: "foc2",
          name: "foc2",
          occupancy: 2,
        },
        {
          text: "FOC Triple",
          value: "foc3",
          name: "foc3",
          occupancy: 3,
        },
        {
          text: "FOC Qaud",
          value: "foc4",
          name: "foc4",
          occupancy: 4,
        },
      ],
    };
  },

  computed: {
    dates() {
      if (this.date) {
        return [this.date];
      }
      const dates = [];

      const from = moment(this.validFrom);
      const to = moment(this.validTo);

      for (const m = moment(from); m.diff(to, "days") <= 0; m.add(1, "days")) {
        if (this.selectedDaysOfWeek.indexOf(m.day().toString()) > -1) {
          const date = m.toISOString(true);
          if (dates.indexOf(date) == -1) {
            dates.push(date);
          }
        }
      }

      return dates;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.dates.length > 0;
    },
    visibleHeaders() {
      if (this.templateItems) {
        const occupancies = this.templateItems
          .filter((item) => item.serviceType == "ACCOMMODATION")
          .map((item) => Number(item.stdOccupancy));

        return this.adjustmentsHeaders.filter(
          (h) => [0, ...occupancies].indexOf(h.occupancy) > -1
        );
      } else {
        return this.adjustmentsHeaders;
      }
    },
  },

  methods: {
    setAdjustments() {
      const list = [];
      let n = Number(this.minPax);
      while (n <= Number(this.maxPax)) {
        if (n + Number(this.step) - 1 <= Number(this.maxPax)) {
          list.push({
            paxFrom: n,
            paxTo: n + Number(this.step) - 1,
            foc1: 0,
            foc2: 0,
            foc3: 0,
            foc4: 0,
          });
        }
        n += Number(this.step);
      }
      this.adjustments = [...list];
    },
    onDatesChange(payload) {
      this.dates = [...payload];
    },
    onAdd() {
      this.$emit("add", {
        uid: randomize("Aa0", 32),
        reference: this.reference,
        dates: this.dates,
        minPax: Number(this.minPax),
        maxPax: Number(this.maxPax),
        step: Number(this.step),
        adjustments: [...this.adjustments],
      });
    },
    onDatesChange(payload) {
      if (payload.dateFrom) {
        this.validFrom = payload.dateFrom;
      }
      if (payload.dateTo) {
        this.validTo = payload.dateTo;
      }
    },
  },
  mounted() {
    this.setAdjustments();
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/increments/AddIncrementDialog.vue